let basePageTitle: string | undefined = document.title;
let currentFullPageTitle: string | undefined = basePageTitle;
let currentTimerDuration: string | undefined = undefined;

type Listener = () => void;
const listeners = new Set<Listener>();

const notifyListeners = () => {
    listeners.forEach((listener) => listener());
};

export const subscribe = (listener: Listener): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export const setBasePageTitle = (title: string | undefined) => {
    basePageTitle = title;
    // Preserve the current timer duration when updating page title
    updateDocumentTitle(currentTimerDuration);
};

export const getFullPageTitle = (): string | undefined => {
    return currentFullPageTitle;
};

export const updateDocumentTitle = (timerDuration?: string) => {
    currentTimerDuration = timerDuration;
    const parts = [timerDuration, basePageTitle].filter(Boolean);
    currentFullPageTitle = parts.length > 0 ? parts.join(' - ') : '';
    document.title = currentFullPageTitle;
    notifyListeners();
};
